import request from '@/utils/request'; // 获取列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/goodsSearch/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/goodsSearch/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/goodsSearch/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/goodsSearch/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/goodsSearch/update',
    method: 'post',
    data: data
  });
}
export function fetchClueList(data) {
  return request({
    url: '/pmsservice/api/goodsFindClue/list',
    method: 'post',
    data: data
  });
}
export function fetchClueCreate(data) {
  return request({
    url: '/pmsservice/api/goodsFindClue/insert',
    method: 'post',
    data: data
  });
}
export function fetchClueDelete(data) {
  return request({
    url: '/pmsservice/api/goodsFindClue/delete',
    method: 'post',
    data: data
  });
}
export function fetchUpdateState(data) {
  return request({
    url: '/pmsservice/api/goodsSearch/updateState',
    method: 'post',
    data: data
  });
}